// extracted by mini-css-extract-plugin
module.exports = {"returnItem":"returnItem--3nOmT"};